import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const money = (v) => `${v < 0 ? '-' : ''}$${Math.abs(v || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
export const cents = (c) => money((c || 0) / 100);
export const when = (iso) => (iso ? new Date(iso.endsWith('Z') || iso.includes('+') ? iso : `${iso}Z`).toLocaleString() : '—');

export const useAdminGet = (path, intervalMs) => {
    const [data, setData] = useState(null);
    const [error, setError] = useState(false);
    const load = useCallback(() => {
        setError(false);
        return axios.get(`${API}${path}`, { withCredentials: true }).then((r) => setData(r.data)).catch(() => setError(true));
    }, [path]);
    useEffect(() => {
        load();
        if (!intervalMs) return undefined;
        const t = setInterval(load, intervalMs);
        return () => clearInterval(t);
    }, [load, intervalMs]);
    return [data, load, error, setData];
};

export const Card = ({ title, right, children, testid }) => (
    <section className="rounded-xl border border-white/10 bg-black/30 p-4" data-testid={testid}>
        <div className="mb-3 flex flex-wrap items-center gap-2">
            <h3 className="mr-auto text-sm font-black uppercase tracking-wider text-white">{title}</h3>
            {right}
        </div>
        {children}
    </section>
);
